import avatar1 from "../../../assets/images/users/avatar-1.jpg"
import avatar2 from "../../../assets/images/users/avatar-2.jpg"
import avatar3 from "../../../assets/images/users/avatar-3.jpg"
import avatar4 from "../../../assets/images/users/avatar-4.jpg"
import avatar5 from "../../../assets/images/users/avatar-5.jpg"
import avatar6 from "../../../assets/images/users/avatar-6.jpg"
import avatar7 from "../../../assets/images/users/avatar-7.jpg"
import avatar8 from "../../../assets/images/users/avatar-8.jpg"
import {
  formatDisplayName,
  getUserFullName,
} from "../../../helpers/userDisplay"

/** Request type tabs — Figma Admin Requests (`40005445:63013`). */
export const REQUEST_TYPE_TABS = [
  { key: "collaborator_limits", label: "Collaborators Limits" },
  { key: "change_city", label: "Change City" },
  { key: "join_platform", label: "Join Platform" },
  { key: "reviewers", label: "Reviewers" },
  { key: "photographers", label: "Photographers" },
]

const toCount = value => {
  const num = Number(value)
  return Number.isFinite(num) ? Math.max(0, num) : 0
}

/** Map GET /api/v1/admin/requests/counts → tab badge counts. */
export const mapRequestTypeTabCounts = (result = {}) =>
  REQUEST_TYPE_TABS.reduce(
    (acc, tab) => ({
      ...acc,
      [tab.key]: toCount(result[tab.key]),
    }),
    {},
  )

const AVATARS = [avatar1, avatar2, avatar3, avatar4, avatar5, avatar6, avatar7, avatar8]

const makeRow = (index, overrides) => ({
  id: `fixture-${index}`,
  requestType: "collaborator_limits",
  name: "Sarah Mitchell",
  avatar: AVATARS[index % AVATARS.length],
  firstName: "Sarah",
  lastName: "Mitchell",
  email: "sarah.m@example.com",
  city: "Dallas, US",
  projectName: "Urban Art Festival",
  reason: "Need more collaborators on this project, team is big.",
  date: "Jul 1, 2025",
  status: "pending",
  currentLimit: "20",
  requestedLimit: "30",
  ...overrides,
})

/** Static rows until dedicated admin request APIs land. */
export const REQUEST_FIXTURE_ROWS = [
  makeRow(1, {
    name: "Sarah Mitchell",
    firstName: "Sarah",
    lastName: "Mitchell",
    email: "sarah.m@example.com",
    city: "Dallas, US",
    projectName: "Urban Art Festival",
    reason: "Need more collaborators on this project, team is big.",
    date: "Jul 1, 2025",
    status: "pending",
    currentLimit: "20",
    requestedLimit: "30",
  }),
  makeRow(2, {
    name: "James Wilson",
    firstName: "James",
    lastName: "Wilson",
    email: "james.w@example.com",
    city: "San Francisco, US",
    projectName: "City Murals Initiative",
    reason: "Requesting more collaborators to handle the project's workload.",
    date: "Jun 30, 2025",
    status: "pending",
    currentLimit: "20",
    requestedLimit: "35",
  }),
  makeRow(3, {
    name: "Emily Chen",
    firstName: "Emily",
    lastName: "Chen",
    email: "emily.c@example.com",
    city: "Berlin, DE",
    projectName: "Gallery Opening Night",
    reason: "Need to add collaborators to meet tight project deadlines.",
    date: "Jun 29, 2025",
    status: "approved",
    currentLimit: "20",
    requestedLimit: "40",
  }),
  makeRow(4, {
    name: "Ryan Carter",
    firstName: "Ryan",
    lastName: "Carter",
    email: "ryan.c@example.com",
    city: "London, UK",
    projectName: "Street Art Collective",
    reason: "Seeking more collaborators to bring diverse expertise to the team.",
    date: "Jul 4, 2025",
    status: "pending",
    currentLimit: "20",
    requestedLimit: "25",
  }),
  makeRow(5, {
    name: "Rachel Kim",
    firstName: "Rachel",
    lastName: "Kim",
    email: "rachel.k@example.com",
    city: "San Francisco, US",
    projectName: "Public Art Commission",
    reason: "Increasing collaborators to improve workflow efficiency.",
    date: "Jul 5, 2025",
    status: "approved",
    currentLimit: "20",
    requestedLimit: "45",
  }),
  makeRow(6, {
    name: "David Park",
    firstName: "David",
    lastName: "Park",
    email: "david.p@example.com",
    city: "Berlin, DE",
    projectName: "Cultural Exchange",
    reason: "More collaborators needed to manage expanding project scope.",
    date: "Jun 28, 2025",
    status: "rejected",
    currentLimit: "20",
    requestedLimit: "30",
  }),
  makeRow(7, {
    name: "Lisa Anderson",
    firstName: "Lisa",
    lastName: "Anderson",
    email: "lisa.a@example.com",
    city: "Dallas, US",
    projectName: "Youth Arts Program",
    reason: "Adding collaborators to enhance creativity and innovation.",
    date: "Jul 1, 2025",
    status: "pending",
    currentLimit: "20",
    requestedLimit: "50",
  }),
  makeRow(8, {
    name: "Marcus Bell",
    firstName: "Marcus",
    lastName: "Bell",
    email: "marcus.b@example.com",
    city: "London, UK",
    projectName: "Digital Art Showcase",
    reason: "Requesting more collaborators to distribute workload evenly.",
    date: "Jun 25, 2025",
    status: "approved",
    currentLimit: "20",
    requestedLimit: "35",
  }),
  makeRow(9, {
    name: "Rachel Kim",
    firstName: "Rachel",
    lastName: "Kim",
    email: "rachel.k@example.com",
    city: "Dallas, US",
    projectName: "Community Mural",
    reason: "Need additional collaborators to accelerate project progress.",
    date: "Jul 5, 2025",
    status: "approved",
    currentLimit: "20",
    requestedLimit: "40",
  }),
  makeRow(10, {
    name: "David Park",
    firstName: "David",
    lastName: "Park",
    email: "david.p@example.com",
    city: "Berlin, DE",
    projectName: "Heritage Restoration",
    reason: "Increasing team size to cover all required skill sets.",
    date: "Jun 28, 2025",
    status: "rejected",
    currentLimit: "20",
    requestedLimit: "25",
  }),
  makeRow(11, {
    name: "Lisa Anderson",
    firstName: "Lisa",
    lastName: "Anderson",
    email: "lisa.a@example.com",
    city: "San Francisco, US",
    projectName: "Pop-up Exhibition",
    reason: "More collaborators needed to support complex project tasks.",
    date: "Jul 1, 2025",
    status: "pending",
    currentLimit: "20",
    requestedLimit: "30",
  }),
  makeRow(12, {
    name: "Sophia Lee",
    firstName: "Sophia",
    lastName: "Lee",
    email: "sophia.l@example.com",
    city: "Austin, US",
    projectName: "Live Painting Series",
    reason: "Collaborator cap is blocking new team members from joining.",
    date: "Jun 27, 2025",
    status: "pending",
    currentLimit: "20",
    requestedLimit: "28",
  }),
  makeRow(13, {
    name: "Andre Williams",
    firstName: "Andre",
    lastName: "Williams",
    email: "andre.w@example.com",
    city: "Chicago, US",
    projectName: "Neighborhood Arts Walk",
    reason: "Need higher limit before the next recruitment round.",
    date: "Jun 26, 2025",
    status: "approved",
    currentLimit: "20",
    requestedLimit: "32",
  }),
  makeRow(14, {
    name: "Tara Kim",
    firstName: "Tara",
    lastName: "Kim",
    email: "tara.k@example.com",
    city: "Seattle, US",
    projectName: "Sound & Light Install",
    reason: "Project scope expanded; current limit is too low.",
    date: "Jun 24, 2025",
    status: "pending",
    currentLimit: "20",
    requestedLimit: "38",
  }),
  makeRow(15, {
    name: "Noah Kim",
    firstName: "Noah",
    lastName: "Kim",
    email: "noah.k@example.com",
    city: "Portland, US",
    projectName: "Winter Arts Market",
    reason: "Additional vendors require more collaborator slots.",
    date: "Jun 23, 2025",
    status: "rejected",
    currentLimit: "20",
    requestedLimit: "42",
  }),
  makeRow(16, {
    name: "Grace Liu",
    firstName: "Grace",
    lastName: "Liu",
    email: "grace.l@example.com",
    city: "Boston, US",
    projectName: "Harbor Light Festival",
    reason: "Raising limit to onboard lighting and stage collaborators.",
    date: "Jun 22, 2025",
    status: "pending",
    currentLimit: "20",
    requestedLimit: "33",
  }),
  makeRow(17, {
    name: "Jordan Hale",
    firstName: "Jordan",
    lastName: "Hale",
    email: "jordan.h@example.com",
    city: "Miami, US",
    projectName: "Coastal Canvas",
    reason: "Team growth planned for the second project phase.",
    date: "Jun 21, 2025",
    status: "approved",
    currentLimit: "20",
    requestedLimit: "36",
  }),
  makeRow(18, {
    name: "Ava Chen",
    firstName: "Ava",
    lastName: "Chen",
    email: "ava.c@example.com",
    city: "Denver, US",
    projectName: "Mountain Studio Residency",
    reason: "Residency cohort size exceeds the current collaborator cap.",
    date: "Jun 20, 2025",
    status: "pending",
    currentLimit: "20",
    requestedLimit: "45",
  }),
  makeRow(19, {
    name: "James Ortiz",
    firstName: "James",
    lastName: "Ortiz",
    email: "james.o@example.com",
    city: "Phoenix, US",
    projectName: "Desert Bloom Exhibit",
    reason: "Need room for installation crew and docents.",
    date: "Jun 19, 2025",
    status: "approved",
    currentLimit: "20",
    requestedLimit: "29",
  }),
  makeRow(20, {
    name: "Maya Collins",
    firstName: "Maya",
    lastName: "Collins",
    email: "maya.c@example.com",
    city: "Atlanta, US",
    projectName: "Southern Voices Forum",
    reason: "Panelists and moderators need collaborator access.",
    date: "Jun 18, 2025",
    status: "pending",
    currentLimit: "20",
    requestedLimit: "34",
  }),
  makeRow(21, {
    name: "Nina Brooks",
    firstName: "Nina",
    lastName: "Brooks",
    email: "nina.b@example.com",
    city: "Nashville, US",
    projectName: "Songwriter Circle",
    reason: "Weekly sessions require a higher collaborator limit.",
    date: "Jun 17, 2025",
    status: "rejected",
    currentLimit: "20",
    requestedLimit: "27",
  }),
  makeRow(22, {
    name: "Lena Harper",
    firstName: "Lena",
    lastName: "Harper",
    email: "lena.h@example.com",
    city: "Minneapolis, US",
    projectName: "Ice Sculpture Jam",
    reason: "Multiple crews need to join before the event date.",
    date: "Jun 16, 2025",
    status: "pending",
    currentLimit: "20",
    requestedLimit: "31",
  }),
  makeRow(23, {
    name: "Ryan Carter",
    firstName: "Ryan",
    lastName: "Carter",
    email: "ryan.c@example.com",
    city: "London, UK",
    projectName: "Bridge Light Project",
    reason: "Final collaborator push before installation week.",
    date: "Jun 15, 2025",
    status: "approved",
    currentLimit: "20",
    requestedLimit: "37",
  }),
  makeRow(24, {
    id: "fixture-change-1",
    requestType: "change_city",
    name: "Alex Rivera",
    firstName: "Alex",
    lastName: "Rivera",
    email: "alex.r@example.com",
    city: "Dallas, US",
    projectName: "--",
    reason: "Relocated to Austin and would like to transfer my home city.",
    date: "Jul 2, 2025",
    status: "pending",
    currentLimit: "--",
    requestedLimit: "--",
  }),
  makeRow(25, {
    id: "fixture-change-2",
    requestType: "change_city",
    name: "Emily Johnson",
    firstName: "Emily",
    lastName: "Johnson",
    email: "emily.j@example.com",
    city: "Berlin, DE",
    projectName: "--",
    reason: "Moving to London for a six-month residency program.",
    date: "Jun 29, 2025",
    status: "approved",
    currentLimit: "--",
    requestedLimit: "--",
  }),
  makeRow(26, {
    id: "fixture-reviewer-1",
    requestType: "reviewers",
    name: "Marcus Bell",
    firstName: "Marcus",
    lastName: "Bell",
    email: "marcus.b@example.com",
    city: "Chicago, US",
    projectName: "--",
    reason: "Applied to become a city reviewer with portfolio attached.",
    date: "Jul 3, 2025",
    status: "pending",
    currentLimit: "--",
    requestedLimit: "--",
  }),
  makeRow(27, {
    id: "fixture-photo-1",
    requestType: "photographers",
    name: "Sophia Lee",
    firstName: "Sophia",
    lastName: "Lee",
    email: "sophia.l@example.com",
    city: "Austin, US",
    projectName: "--",
    reason: "Requesting verified photographer status for city galleries.",
    date: "Jul 4, 2025",
    status: "pending",
    currentLimit: "--",
    requestedLimit: "--",
  }),
]

export const COLLABORATOR_LIMIT_WITH = ["user", "project.cities.city"]

export const CITY_UPDATE_REQUEST_WITH = [
  "user",
  "editCity",
  "newCity",
  "actionBy",
]

const formatRequestCity = city => {
  if (!city) return "--"
  const name = city.city || ""
  const country = city.country || ""
  if (name && country) return `${name}, ${country}`
  return name || country || "--"
}

/** Resolve project city from with[]=project.cities.city (prefer over user address). */
const resolveCollaboratorLimitCity = (item = {}) => {
  const project = item.project || {}
  const cities = Array.isArray(project.cities) ? project.cities : []
  const first = cities[0]
  if (first?.city && typeof first.city === "object") return first.city
  if (project.city && typeof project.city === "object") return project.city
  return null
}

const formatRequestDate = value => {
  if (!value) return "--"
  try {
    const parsed = new Date(value)
    if (Number.isNaN(parsed.getTime())) return "--"
    return parsed.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })
  } catch {
    return "--"
  }
}

const mapRequestUser = (user = {}) => {
  const firstName = formatDisplayName(user.first_name || "")
  const lastName = formatDisplayName(user.last_name || "")
  const name =
    getUserFullName({
      full_name: user.full_name,
      first_name: firstName,
      last_name: lastName,
      email: user.email,
    }) || "Unknown"

  return {
    name,
    firstName: firstName || "--",
    lastName: lastName || "--",
    email: user.email || "",
    avatar:
      user.profile_media?.thumbnail ||
      user.profile_media?.image ||
      user.thumbnail ||
      user.image ||
      "",
  }
}

/**
 * Map GET /api/v1/admin/collaborator-limits item → table / modal row.
 * City comes from the project (`with[]=project.cities.city`), not the user.
 */
export const mapCollaboratorLimitRequest = item => {
  const user = item.user || {}
  const project = item.project || {}
  const city = resolveCollaboratorLimitCity(item)
  const mappedUser = mapRequestUser(user)

  return enrichRequestRow({
    id: item.id,
    requestType: "collaborator_limits",
    ...mappedUser,
    city: formatRequestCity(city),
    cityId: city?.id || project.cities?.[0]?.city_id || "",
    projectId: item.project_id || project.id || "",
    projectName: project.name || "--",
    reason: item.reason || "--",
    date: formatRequestDate(item.created_at),
    status: item.status,
    currentLimit:
      project.collaborator_limit != null
        ? String(project.collaborator_limit)
        : "--",
    requestedLimit: item.limit != null ? String(item.limit) : "--",
    approvedCount:
      item.approved_count != null ? String(item.approved_count) : "",
    decisionReason: item.action_reason || "",
    handledAt: item.action_at ? formatRequestDate(item.action_at) : "",
    raw: item,
  })
}

/**
 * Map GET /api/v1/admin/city-update-requests item → table / modal row.
 */
export const mapCityUpdateRequest = item => {
  const user = item.user || {}
  const editCity = item.edit_city || item.editCity || null
  const newCity = item.new_city || item.newCity || null
  const mappedUser = mapRequestUser(user)
  const currentCity = formatRequestCity(editCity)
  const requestedCity = formatRequestCity(newCity)
  const actionBy = item.action_by || item.actionBy || null

  return enrichRequestRow({
    id: item.id,
    requestType: "change_city",
    ...mappedUser,
    city: currentCity,
    cityId: editCity?.id || item.edit_city_id || "",
    newCity: requestedCity,
    newCityId: newCity?.id || item.new_city_id || "",
    cityChangeLabel:
      currentCity !== "--" || requestedCity !== "--"
        ? `${currentCity} → ${requestedCity}`
        : "--",
    projectName: "--",
    reason: item.reason || "--",
    date: formatRequestDate(item.created_at),
    status: item.status,
    currentLimit: "--",
    requestedLimit: "--",
    decisionReason: item.action_reason || "",
    handlerName: actionBy ? getUserFullName(actionBy) : "",
    handledAt: item.action_at ? formatRequestDate(item.action_at) : "",
    raw: item,
  })
}

/**
 * Map GET /api/v1/admin/photography-collaborator item → table / modal row.
 * `cityLabelById` resolves city_id when the list payload has no nested city.
 */
export const mapPhotographyCollaboratorRequest = (
  item,
  cityLabelById = {},
) => {
  const user = item.user || {}
  const city = item.city || null
  const mappedUser = mapRequestUser(user)
  const hasUser = Boolean(
    user.id || user.email || user.first_name || user.full_name,
  )
  const cityLabel = city
    ? formatRequestCity(city)
    : cityLabelById[item.city_id] || "--"

  return enrichRequestRow({
    id: item.id,
    requestType: "photographers",
    ...mappedUser,
    name: hasUser ? mappedUser.name : item.subject || "Photography request",
    firstName: hasUser ? mappedUser.firstName : item.subject || "--",
    lastName: hasUser ? mappedUser.lastName : "",
    email: hasUser ? mappedUser.email : "",
    city: cityLabel,
    cityId: item.city_id || city?.id || "",
    projectName: "--",
    subject: item.subject || "",
    reason: item.message || item.subject || "--",
    portfolioLink: item.portfolio_link || "",
    date: formatRequestDate(item.created_at),
    status: item.status,
    currentLimit: "--",
    requestedLimit: "--",
    decisionReason: item.action_reason || "",
    raw: item,
  })
}

/** Photography API uses `accepted` instead of `approved`. */
export const toPhotographyApiStatus = status =>
  status === "approved" ? "accepted" : status

/** Review writer / photography-style APIs use `accepted` instead of `approved`. */
export const toAcceptedApiStatus = toPhotographyApiStatus

/**
 * Map GET /api/v1/admin/review-writer-request item → table / modal row.
 */
export const mapReviewWriterRequest = (item, cityLabelById = {}) => {
  const user = item.user || {}
  const city = item.city || null
  const mappedUser = mapRequestUser(user)
  const hasUser = Boolean(
    user.id || user.email || user.first_name || user.full_name,
  )
  const cityLabel = city
    ? formatRequestCity(city)
    : cityLabelById[item.city_id] || "--"
  const areas = Array.isArray(item.areas_of_interest)
    ? item.areas_of_interest.filter(Boolean)
    : []

  return enrichRequestRow({
    id: item.id,
    requestType: "reviewers",
    ...mappedUser,
    name: hasUser ? mappedUser.name : "Review writer request",
    firstName: hasUser ? mappedUser.firstName : "--",
    lastName: hasUser ? mappedUser.lastName : "",
    email: hasUser ? mappedUser.email : "",
    city: cityLabel,
    cityId: item.city_id || city?.id || "",
    projectName: "--",
    whatToReviewFirst: item.what_to_review_first || "",
    whyWriteReviews: item.why_write_reviews || "",
    areasOfInterest: areas,
    reason: item.why_write_reviews || item.what_to_review_first || "--",
    date: formatRequestDate(item.created_at),
    status: item.status,
    currentLimit: "--",
    requestedLimit: "--",
    decisionReason: item.action_reason || "",
    raw: item,
  })
}

export const enrichRequestRow = row => {
  const status = String(row.status || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")

  const normalized =
    !status ||
    status === "open" ||
    status === "requested" ||
    status === "waiting" ||
    status === "new"
      ? "pending"
      : status === "accepted" || status === "resolved" || status === "approve"
        ? "approved"
        : status === "dismissed" || status === "denied" || status === "deny"
          ? "rejected"
          : status

  const statusLabel =
    normalized === "rejected"
      ? "Rejected"
      : normalized === "approved"
        ? "Approved"
        : normalized === "pending"
          ? "Pending"
          : normalized === "withdrawn"
            ? "Withdrawn"
            : row.statusLabel || "--"

  const statusTone =
    normalized === "approved"
      ? "resolved"
      : normalized === "pending"
        ? "open"
        : "dismissed"

  return {
    ...row,
    status: normalized,
    statusLabel,
    statusTone,
  }
}
